import React, { useState } from "react";
import { Turn } from "hamburger-react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classes from "./HamburgerMenu.module.css";
import LanguageDropDownComponent from "../../components/languageDropdown/LanguageDropDownComponent";
/* import ToggleSwitches from "../../../ToggleSwitches"; */

// Define the dropdown items here (or import them if they are available globally)
const dropdownItems = {
  universitet: [
    { path: "/about", text: "Universitet haqida" },
    { path: "/statistics", text: "RTU raqamlarda" },
    { path: "/centers", text: "universityStructure" },
    { path: "/management", text: "Rahbariyat" },
    { path: "/faculties", text: "Kafedra va fakultetlar" },
    { path: "/dropdown/oquv-binolari", text: "O'quv binolari" },
    { path: "/directions", text: "Yo'nalishlar" },
    { path: "/documents/sifat-siyosati", text: "Sifat siyosati" },
    { path: "/documents/normativ-huquqiy-hujjatlar", text: "document" },
  ],
  ilmiyFaoliyat: [
    {
      text: "Ilmiy faoliyat",
      children: [
        { path: "/activity/ilmiy-faoliyat/ilmiy-jarayonlar", text: "Ilmiy jarayonlar" },
        { path: "/ilmiy-kengash", text: "Universitet kengashi" },
        { path: "https://conference.renessans-edu.uz/", text: "Ilmiy konferensiyalar" },
        { path: "/activity/ilmiy-faoliyat/ilmiy-maktablar", text: "Ilmiy maktablar" },
        { path: "/activity/ilmiy-faoliyat/oquv-va-labaratoriya-bazalari", text: "O'quv va labaratoriya bazalari" },
        { path: "/activity/ilmiy-faoliyat/yosh-akademiklar", text: "Yosh akademiklar" },
        { path: "/avtoreferat-dissertatsiya", text: "Avtoreferat va dissertatsiya" },
      ]
    },
    {
      text: "Madaniy-ma'rifiy faoliyat",
      children: [
        { path: "/activity/madaniy-ma'rifiy-faoliyat/manaviyat-va-marifat-kengashi", text: "Ma'naviyat va ma'rifat Kengashi" },
        { path: "/activity/madaniy-ma'rifiy-faoliyat/fan-va-jamoat-arboblari-bilan-muloqotlar", text: "Fan va jamoat arboblari bilan muloqotlar" },
        { path: "/activity/madaniy-ma'rifiy-faoliyat/manaviy-marifiy-tadbirlar", text: "Ma'naviy-ma'rifiy tadbirlar" },
        { path: "/activity/madaniy-ma'rifiy-faoliyat/murabbiylar-faoliyati", text: "Murabbiylar faoliyati" },
        { path: "/activity/madaniy-ma'rifiy-faoliyat/xotin-qizlar", text: "Xotin-qizlar" },
        { path: "/activity/madaniy-ma'rifiy-faoliyat/tanlovlar", text: "Tanlovlar" },
      ]
    },
    {
      text: "O'quv faoliyat",
      children: [
        { path: "/activity/oquv-faoliyat/oquv-jarayoni", text: "Oʻquv jarayoni" },
        { path: "/activity/oquv-faoliyat/video-maruzalar", text: "Elektron kontentlar" },
        { path: "/activity/oquv-faoliyat/oquv-reja-va-dasturlar", text: "oquv_reja_va_dasturlar" },
        { path: "/activity/oquv-faoliyat/nazorat-sinovlari", text: "Nazorat sinovi va namunalari" },
        { path: "/activity/oquv-faoliyat/yakuniy-nazoratlar", text: "Yakuniy nazoratlar" },
        { path: "/activity/oquv-faoliyat/bmi-mavzular/", text: "BMI mavzular" },
      ]
    },
    // {
    // text: "O'quv-uslubiy ta'minot",
    // children: [
    //   { path: "/dropdown/yosh-akademiklar", text: "Yosh akademiklar" },
    //   { path: "/dropdown/zakovat-klubi", text: "Zakovat klubi" },
    //   { path: "/dropdown/talabalar-turar-joyi", text: "Talabalar turar joyi" },
    //   { path: "/dropdown/sport-klubi", text: "Sport klubi" },
    //   { path: "/dropdown/axborot-resurs-markazi", text: "Axborot resurs markazi" },
    // ]
    // },
  ],
  talabalarga: [
    { path: "/baseactivities/talabalar-hayoti/", text: "Talabalar hayoti" },
    { path: "/activity/talabalarga/karyera/", text: "Karyera" },
    { path: "/university-union", text: "universityUnion" },
    { path: "/activity/talabalarga/yoshlar-ittifoqi", text: "Yoshlar ittifoqi" },
    { path: "/activity/talabalarga/talabalar-turar-joyi", text: "Talabalar turar joyi" },
    { path: "/activity/talabalarga/alochi-talabalar", text: "Iqtidorlilar va chempionlar" },
    { path: "/activity/talabalarga/stipendiantlar", text: "Stipendiantlar" },
    { path: "/activity/talabalarga/bitiruvchilar", text: "Bizning bitiruvchilar" },
    { path: "/interaktiv-xizmatlar", text: "Interaktiv xizmatlar" },
  ],
  hamkorlik: [
    { path: "/activity/hamkorlik/xalqaro-aloqalar", text: "Xalqaro aloqalar" },
    { path: "/confession", text: "Xalqaro e'tirof" },
    { path: "/activity/hamkorlik/xorijda-talim", text: "Talabalarimiz xorijda" },
    { path: "/activity/hamkorlik/professor-oqituvchilar-stajirovkasi", text: "Professor-o‘qituvchilar stajirovkasi" },
    { path: "/partners", text: "partners" },
    { path: "/activity/ilmiy-faoliyat/green-renessans", text: "Green Renessans" },
  ],
  qabul: [
    { path: "/qabul/abituriyentlar", text: "Abituriyentlarga" },
    { path: "/qabul/bakalavr", text: "Bakalavr" },
    { path: "/qabul/oqishni-kochirish", text: "O'qishni ko'chirish" },
    { path: "/qabul/magistratura", text: "Magistratura" },
    { path: "/qabul/tolov-kontrakt", text: "To'lov kontrakt miqdori" },
  ],
  bizningFaoliyat: [
    { path: "/news", text: "Yangiliklar" },
    { path: "/announce", text: "E'lonlar" },
    // { path: "/anons", text: t("Tadbirlar") },
    { path: "/contact", text: "Bog'lanish" },
  ],
};

const mainRoutes = [
  { text: "Universitet", dropdown: "universitet" },
  { text: "Faoliyat", dropdown: "ilmiyFaoliyat" },
  { text: "Hamkorlik", dropdown: "hamkorlik" },
  { text: "Talabalarga", dropdown: "talabalarga" },
  { text: "Qabul", dropdown: "qabul" },
  { text: "Axborot xizmati", dropdown: "bizningFaoliyat" }
];

const HamburgerMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [openIlmiy, setOpenIlmiy] = useState(false);
  const [openMadaniy, setOpenMadaniy] = useState(false);
  const [openOquv, setOpenOquv] = useState(false);
  const [openOquvUslubiy, setOpenOquvUslubiy] = useState(false);
  const [openXalqaroHamkorlik, setOpenXalqaroHamkorlik] = useState(false);
  const [openMahalliyHamkorlik, setOpenMahalliyHamkorlik] = useState(false);

  if (open) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  const handleDropdownToggle = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const active = ({ isActive }) => ({
    color: isActive ? "var(--primary-color)" : "var(--txt-dark-grey-color)",
  });

  return (
    <div className={classes["wrapper"]}>
      <Turn toggled={open} toggle={setOpen} />
      <div
        style={open ? { transform: "translateX(0)" } : null}
        className={classes["hamburger"]}
      >
        <div className={classes["nav-items"]}>
          {mainRoutes.map((item, index) => (
            <div key={index}>
              <div
                className={classes["item"]}
                onClick={() =>
                  item.dropdown
                    ? handleDropdownToggle(item.dropdown)
                    : setOpen(false)
                }
              >
                {t(item.text)}
              </div>
              {item.dropdown && activeDropdown === item.dropdown && (
                <div className={classes["dropdown"]}>
                  {dropdownItems[item.dropdown].map((subItem, subIndex) => {
                    if (subItem.children) { // Check if it's a nested dropdown
                      let openState, setOpenState;
                      switch (subItem.text) {
                        case "Ilmiy faoliyat":
                          openState = openIlmiy;
                          setOpenState = setOpenIlmiy;
                          break;
                        case "Madaniy-ma'rifiy faoliyat":
                          openState = openMadaniy;
                          setOpenState = setOpenMadaniy;
                          break;
                        case "O'quv faoliyat":
                          openState = openOquv;
                          setOpenState = setOpenOquv;
                          break;
                        case "O'quv-uslubiy ta'minot":
                          openState = openOquvUslubiy;
                          setOpenState = setOpenOquvUslubiy;
                          break;
                        case "Xalqaro hamkorlik":
                          openState = openXalqaroHamkorlik;
                          setOpenState = setOpenXalqaroHamkorlik;
                          break;
                        case "Mahalliy hamkorlik":
                          openState = openMahalliyHamkorlik;
                          setOpenState = setOpenMahalliyHamkorlik;
                          break;
                        default:
                          openState = false;
                          setOpenState = () => { }; // No-op for safety
                      }
                      return (
                        <div key={subIndex}>
                          <div
                            className={classes["dropdown-item"]}
                            style={{ cursor: "pointer" }}
                            onClick={() => setOpenState((prev) => !prev)}
                          >
                            {t(subItem.text)}
                          </div>
                          {openState && (
                            <div style={{ paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: '0' }}>
                              {subItem.children.map((childItem, childIndex) => (
                                childItem.path.startsWith('http') ? (
                                  <a
                                    key={childIndex}
                                    href={childItem.path}
                                    className={classes["dropdown-item"]}
                                    style={active({ isActive: false })}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setOpen(false)}
                                  >
                                    {t(childItem.text)}
                                  </a>
                                ) : (
                                  <NavLink
                                    key={childIndex}
                                    to={childItem.path}
                                    className={classes["dropdown-item"]}
                                    style={active}
                                    onClick={() => setOpen(false)}
                                  >
                                    {t(childItem.text)}
                                  </NavLink>
                                )
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      return subItem.path.startsWith('http') ? (
                        <a
                          key={subIndex}
                          href={subItem.path}
                          className={classes["dropdown-item"]}
                          style={active({ isActive: false })}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => setOpen(false)}
                        >
                          {t(subItem.text)}
                        </a>
                      ) : (
                        <NavLink
                          key={subIndex}
                          to={subItem.path}
                          className={classes["dropdown-item"]}
                          style={active}
                          onClick={() => setOpen(false)}
                        >
                          {t(subItem.text)}
                        </NavLink>
                      );
                    }
                  })}
                </div>
              )}
            </div>
          ))}
          <NavLink onClick={() => setOpen(false)} to={"/auth"}>
            <div className={classes["login-button"]}>
              {t("rektorgamurojat")}
            </div>
          </NavLink>
          <div className={classes["mobile-controls"]}>
            <LanguageDropDownComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;
